import { MAX_PARTICLES } from '../core/Constants';

/**
 * Particle system for brick explosions and impacts
 */
export class ParticleSystem {
  constructor() {
    this.particles = [];
  }

  spawn(x, y, colorIndex = 1, count = 8) {
    for (let i = 0; i < count; i++) {
      if (this.particles.length >= MAX_PARTICLES) {
        this.particles.shift();
      }
      const angle = Math.random() * Math.PI * 2;
      const speed = 1.0 + Math.random() * 4.0;
      this.particles.push({
        x,
        y,
        vx: Math.cos(angle) * speed,
        vy: Math.sin(angle) * speed - 1.0,
        colorIndex,
        life: 1.0,
        decay: 1.5 + Math.random() * 2.0,
      });
    }
  }

  update(dt) {
    for (let i = this.particles.length - 1; i >= 0; i--) {
      const p = this.particles[i];
      p.x += p.vx * dt * 60;
      p.y += p.vy * dt * 60;
      p.vy += 0.15 * dt * 60; // Gravity
      p.life -= p.decay * dt;
      if (p.life <= 0) {
        this.particles.splice(i, 1);
      }
    }
  }

  clear() {
    this.particles = [];
  }

  /**
   * Returns flat Float32Array for WebGL uniform `u_particles[MAX_PARTICLES]`
   * Each entry: [x, y, colorIndex, life]
   */
  getUniformData() {
    const data = new Float32Array(MAX_PARTICLES * 4);
    for (let i = 0; i < MAX_PARTICLES; i++) {
      if (i < this.particles.length) {
        const p = this.particles[i];
        data[i * 4 + 0] = p.x;
        data[i * 4 + 1] = p.y;
        data[i * 4 + 2] = p.colorIndex;
        data[i * 4 + 3] = p.life;
      } else {
        data[i * 4 + 0] = 0;
        data[i * 4 + 1] = 0;
        data[i * 4 + 2] = 0;
        data[i * 4 + 3] = 0;
      }
    }
    return data;
  }
}
